/**
 * Drop Header
 * Announcement bar and header sit in normal document flow on load.
 * Once the user scrolls past the announcement bar, the header becomes fixed
 * at the top of the viewport (.is-stuck) and the next section gets a top
 * margin equal to the header's height so content doesn't jump under it.
 */
(function () {
  'use strict';

  const CLOSE_DELAY_MS = 150;
  const ANNOUNCEMENT_HEIGHT = 44; // height of .drop-announcement bar

  const header = document.querySelector('.drop-header');
  if (!header) return;

  /* ---------------------------------------------------------------------
     Scroll: toggle .is-stuck and apply margin to next section when stuck
     --------------------------------------------------------------------- */
  const headerSection = header.closest('.shopify-section');
  const nextSection = headerSection ? headerSection.nextElementSibling : null;

  const onScroll = () => {
    if (window.scrollY >= ANNOUNCEMENT_HEIGHT) {
      header.classList.add('is-stuck');
      if (nextSection) {
        nextSection.style.marginTop = header.offsetHeight + 'px';
      }
    } else {
      header.classList.remove('is-stuck');
      if (nextSection) {
        nextSection.style.marginTop = '';
      }
    }
  };

  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  /* ---------------------------------------------------------------------
     Flyout menu behavior
     --------------------------------------------------------------------- */
  const navItems = header.querySelectorAll('.drop-header-nav-item.has-flyout');
  if (!navItems.length) return;

  const overlay = document.createElement('div');
  overlay.className = 'drop-header-overlay';
  document.body.appendChild(overlay);

  let openItem = null;
  let closeTimeout = null;

  const openFlyout = (item) => {
    clearTimeout(closeTimeout);
    if (openItem && openItem !== item) {
      openItem.classList.remove('is-open');
    }
    item.classList.add('is-open');
    overlay.classList.add('is-active');
    openItem = item;
  };

  const closeFlyout = () => {
    if (openItem) {
      openItem.classList.remove('is-open');
      openItem = null;
    }
    overlay.classList.remove('is-active');
  };

  const scheduleClose = () => {
    clearTimeout(closeTimeout);
    closeTimeout = setTimeout(closeFlyout, CLOSE_DELAY_MS);
  };

  navItems.forEach((item) => {
    item.addEventListener('mouseenter', () => openFlyout(item));
    item.addEventListener('mouseleave', scheduleClose);

    const flyout = item.querySelector('.drop-header-flyout');
    if (flyout) {
      flyout.addEventListener('mouseenter', () => clearTimeout(closeTimeout));
      flyout.addEventListener('mouseleave', scheduleClose);
    }

    item.addEventListener('focusin', () => openFlyout(item));
    item.addEventListener('focusout', (e) => {
      if (!item.contains(e.relatedTarget)) {
        scheduleClose();
      }
    });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeFlyout();
  });

  overlay.addEventListener('click', closeFlyout);
  /* ---------------------------------------------------------------------
   Mobile menu
   --------------------------------------------------------------------- */
const mobile = document.querySelector('.drop-mobile');
const mobileToggle = document.querySelector('.drop-header-mobile-toggle');

if (mobile && mobileToggle) {
  // Position the mobile menu below the header
  const positionMobile = () => {
    const headerRect = header.getBoundingClientRect();
    const topOffset = headerRect.bottom; // bottom edge of header relative to viewport
    mobile.style.setProperty('--drop-mobile-top', topOffset + 'px');
  };

  positionMobile();
  window.addEventListener('resize', positionMobile);
  window.addEventListener('scroll', positionMobile, { passive: true });
  const overlay = mobile.querySelector('.drop-mobile-overlay');

  const backButtons = mobile.querySelectorAll('.drop-mobile-back');
  const submenuTriggers = mobile.querySelectorAll('[data-mobile-submenu]');
  const level1 = mobile.querySelector('.drop-mobile-level-1');

 const openMobile = () => {
  mobile.classList.add('is-open');
  mobileToggle.classList.add('is-active');
  document.body.classList.add('drop-mobile-open');
  mobileToggle.setAttribute('aria-expanded', 'true');
  mobile.setAttribute('aria-hidden', 'false');
};

const closeMobile = () => {
  mobile.classList.remove('is-open');
  mobileToggle.classList.remove('is-active');
  document.body.classList.remove('drop-mobile-open');
  mobileToggle.setAttribute('aria-expanded', 'false');
  mobile.setAttribute('aria-hidden', 'true');
  setTimeout(showLevel1, 300);
};

  const showLevel1 = () => {
    mobile.querySelectorAll('.drop-mobile-level').forEach((lvl) => {
      lvl.classList.remove('is-active');
    });
    level1.classList.add('is-active');
  };

const showSubmenu = (handle) => {
  const submenu = mobile.querySelector(`[data-submenu="${handle}"]`);
  if (!submenu) return;
  level1.classList.remove('is-active');
  submenu.classList.add('is-active');

  // Reset horizontal scroll on the products grid so it always starts at the first item
  const productsGrid = submenu.querySelector('.drop-mobile-products-grid');
  if (productsGrid) {
    productsGrid.scrollLeft = 0;
  }
};

  mobileToggle.addEventListener('click', () => {
  if (mobile.classList.contains('is-open')) {
    closeMobile();
  } else {
    openMobile();
  }
});
overlay.addEventListener('click', closeMobile);

  backButtons.forEach((btn) => btn.addEventListener('click', showLevel1));
  submenuTriggers.forEach((btn) => {
    btn.addEventListener('click', () => {
      const handle = btn.getAttribute('data-mobile-submenu');
      showSubmenu(handle);
    });
  });

  // Close on Escape (already handled for flyouts, add mobile too)
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && mobile.classList.contains('is-open')) {
      closeMobile();
    }
  });
}
})();